import React from "react";

interface OverrideIconProps {
    size?: number;
    color?: string;
}

const OverrideIcon: React.FC<OverrideIconProps> = ({ size = 12, color = "white" }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path
                d="M2.70995 9.86093C2.21482 8.9713 0.92397 6.88546 0.340433 5.95374C-0.331518 4.99197 0.110555 4.82667 0.641043 4.87175C1.06543 4.90781 1.5134 5.32759 1.68434 5.53297C1.83759 5.7684 2.23604 6.33845 2.60385 6.73518C3.06361 7.23109 3.43495 7.30623 3.52336 7.2912C3.61178 7.27618 3.84166 7.2912 4.12458 6.81032C4.35092 6.42561 4.32499 5.21739 4.28373 4.66136C4.24836 3.64449 4.17763 1.51457 4.17763 1.12986C4.17763 0.648974 4.31909 0.378475 4.84958 0.318365C5.27397 0.270276 5.43901 0.889416 5.46849 1.205L5.71605 4.18048C5.7632 4.50608 5.89288 5.16028 6.03434 5.1723C6.1758 5.18432 6.30548 4.72648 6.35263 4.49606C6.58251 3.57937 7.07763 1.57167 7.2191 0.874389C7.39593 0.00278389 7.71422 -0.0122438 8.17397 0.00278384C8.54178 0.014806 8.49227 0.729121 8.42154 1.08478C8.26239 1.84618 7.89812 3.62145 7.71422 4.63131C7.53032 5.64117 7.9441 5.13223 8.17397 4.75153C8.60426 3.95506 9.53556 2.20283 9.81849 1.56566C10.1721 0.769195 10.5435 0.814278 10.8618 1.08478C11.1164 1.30117 10.626 2.46732 10.349 3.02335C9.98942 3.72464 9.22788 5.24744 9.05812 5.72833C8.88837 6.20921 9.25853 6.0389 9.46483 5.89363L10.8618 4.00014C11.0032 3.78475 11.3852 3.39904 11.7813 3.57937C12.1774 3.7597 11.9463 4.23558 11.7813 4.45097C11.5219 4.87175 10.7986 6.1307 10.5 6.73518C10.0695 7.60679 9.78312 9.0795 9.37641 10.0863C8.96971 11.0932 7.89105 11.9047 6.10507 11.9949C4.31909 12.085 3.32885 10.973 2.70995 9.86093Z"
                fill={color}
            />
        </svg>
    );
};

export default OverrideIcon;
